<template>
  <div class="sidebar-wrapper">
    <div class="sidebar-header" @click="handleBackToHomePage()">
      Unsplash
    </div>
    <div class="sidebar-items-wrapper">
      <div class="sidebar-item">
        <router-link to="/s/photos/cars">Cars</router-link>
      </div>
      <div class="sidebar-item">
        <router-link to="/s/photos/wallpapers">Wallpapers</router-link>
      </div>
      <div class="sidebar-item">
        <router-link to="/s/photos/travel">Travel</router-link>
      </div>
      <div class="sidebar-item">
        <router-link to="/s/photos/nature">Nature</router-link>
      </div>
      <div class="sidebar-item">
        <router-link to="/s/photos/people">People</router-link>
      </div>
      <div class="sidebar-item">
        <router-link to="/s/photos/business">Business & Work</router-link>
      </div>
      <div class="sidebar-item">
        <router-link to="/s/photos/technology">Technology</router-link>
      </div>
      <div class="sidebar-item">
        <router-link to="/s/photos/animals">Animals</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Sidebar",
    methods: {
      handleSidebarItems(item) {
        this.$router.push(`/s/photos/${item}`);
      },
      handleBackToHomePage() {
        this.$router.push("/");
      },
    },
  };
</script>

<style lang="scss" scoped>
  .sidebar-wrapper {
    min-width: 13%;
    height: 100%;
    min-height: 100vh;
    background: white;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.06);
    overflow: hidden;

    .sidebar-header {
      width: 100%;
      height: 10%;
      background: linear-gradient(300deg, #fe8c00, #f83600);
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 900;
      font-size: 2rem;
      text-transform: uppercase;
      color: white;
      cursor: pointer;
    }
    .sidebar-items-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 2rem;
      cursor: pointer;

      .sidebar-item {
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;
        background: transparent;
        padding-left: 2rem;
        font-weight: 500;
        font-size: 18px;
        color: #2d2d2d;
        transition: all 0.2s linear;

        &:hover {
          background: linear-gradient(300deg, #fe8c00, #f83600);
          color: white;
        }

        a {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          text-decoration: none;
          color: currentColor;
        }
      }
    }
  }
</style>
